module.exports = __webpack_public_path__ + "img/113.7afed49e.svg";